import { TableName } from '@openx/components-table/Table';
import type { SynchronizedWith } from '@openx/types/deal';
import { useMemo } from 'react';
import { FAILED_TO_SYNC_STATUS } from '../constants';
import { parsePdpErrorJson } from '../utils/parsePdpError';
import { SyncErrorsSection } from './SyncErrorsSection';

type TddSyncErrorsSectionProps = {
  pdpLastSyncError?: NonNullable<SynchronizedWith['pdp_sync']>['pdp_last_sync_error'];
  syncStatus: string | undefined;
};

export const TddSyncErrorsSection = ({ pdpLastSyncError, syncStatus }: TddSyncErrorsSectionProps) => {
  const hasErrorsToShow = !!pdpLastSyncError?.errors.length && syncStatus === FAILED_TO_SYNC_STATUS;

  const errors = useMemo(
    () => (hasErrorsToShow ? (pdpLastSyncError?.errors ?? []).map(parsePdpErrorJson) : []),
    [hasErrorsToShow, pdpLastSyncError?.errors]
  );

  return (
    <SyncErrorsSection
      errors={errors}
      lastErrorDatetime={pdpLastSyncError?.error_datetime}
      tableName={TableName.DEAL_TDD_SYNC_ERRORS}
    />
  );
};
